module.exports = __webpack_public_path__ + "img/reserveDental.159ccf61.png";